import { Converter } from '../types/converter';

export const surfaceChargeDensityConverter: Converter = {
  id: 'surfaceChargeDensity',
  name: 'Surface Charge Density Converter',
  icon: 'Square',
  categories: ['electricity'],
  units: [
    // Base SI unit
    { name: 'Coulomb/square meter', symbol: 'C/m²', factor: 1 },
    { name: 'Coulomb/square centimeter', symbol: 'C/cm²', factor: 10000 },
    { name: 'Coulomb/square inch', symbol: 'C/in²', factor: 1550.0031000062 },
    
    // CGS units
    { name: 'Abcoulomb/square meter', symbol: 'abC/m²', factor: 10 },
    { name: 'Abcoulomb/square centimeter', symbol: 'abC/cm²', factor: 100000 },
    { name: 'Abcoulomb/square inch', symbol: 'abC/in²', factor: 15500.031000062 }
  ]
};
